
export default class PFileUpload {

  constructor (inputContainer) {
    this.container = inputContainer
    this.input = this.container.querySelector("input")
    this.filesSelectedContainer = this.container.querySelector('.files-uploaded')
    this.name = this.input.getAttribute('name')

    this.filesArr = []

    this.deleteSvg = '<button type="button" class="remove-file-item"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '<path d="M3 9L9.00004 2.99996" stroke="#111D15" stroke-linecap="round" stroke-linejoin="round"/>\n' +
      '<path d="M9.00004 9.00004L3 3" stroke="#111D15" stroke-linecap="round" stroke-linejoin="round"/>\n' +
      '</svg></button>\n';


    this.fileIconSvg = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '<path d="M18.3327 8.33268V12.4993C18.3327 16.666 16.666 18.3327 12.4993 18.3327H7.49935C3.33268 18.3327 1.66602 16.666 1.66602 12.4993V7.49935C1.66602 3.33268 3.33268 1.66602 7.49935 1.66602H11.666" stroke="#111D15" stroke-linecap="round" stroke-linejoin="round"/>\n' +
      '<path d="M18.3327 8.33268H14.9993C12.4993 8.33268 11.666 7.49935 11.666 4.99935V1.66602L18.3327 8.33268Z" stroke="#111D15" stroke-linecap="round" stroke-linejoin="round"/>\n' +
      '<path d="M5.83398 10.834H10.834" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>\n' +
      '<path d="M5.83398 14.166H9.16732" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>\n' +
      '</svg>\n';

    this.state = {}

    this.addEventListener()
  }

  addEventListener() {

    const self = this

    // upload multiple files
    this.input.addEventListener('change', (e) => {

      let inputFiles = this.input.files;

      self.filesArr = self.filesArr.concat(Array.from(inputFiles));

      this.updateState({ files: inputFiles, filesArr: self.filesArr });

      this.renderFileList();

    })

  }

  // remove files from upload
  addRemoveEventListener() {

    const self = this;
    const files = this.filesSelectedContainer.querySelectorAll('[data-file-key]')

    files.forEach((file) => {

      const removeBtn = file.querySelector('.remove-file-item')

      removeBtn.addEventListener('click', () => {

        let key = file.getAttribute('data-file-key')
        let currentArr =  self.state.filesArr

        currentArr.splice(key, 1);

        self.updateState( { filesArr: currentArr })

        self.renderFileList()

      })

    })

  }

  updateState(newState) {
    this.state = { ...this.state, ...newState };
  }

  renderFileList() {

    const uploadedLines = this.state.filesArr.map((file, index) => {

      let suffix = "B";
      let size = file.size;

      if (size >= 1024 && size < 1024000) {
        suffix = "KB";
        size = Math.round(size / 1024 * 100) / 100;
      } else if (size >= 1024000) {
        suffix = "MB";
        size = Math.round(size / 1024000 * 100) / 100;
      }

      const validation = this.validateFile(file)

      let fileHtml = `<div data-file-key="${index}">${this.fileIconSvg}${ file.name} <span class="file-size">${size} ${suffix}</span>${this.deleteSvg}</div>`

      if(validation.error) {
        fileHtml = `<div class="file-error" data-file-key="${index}"><span>${this.fileIconSvg}${ file.name} - ${validation.message}</span>${this.deleteSvg}</div>`;
      }

      return fileHtml;
    });

    this.filesSelectedContainer.innerHTML = ''

    if(uploadedLines) {

      uploadedLines.forEach(line => {
        this.filesSelectedContainer.insertAdjacentHTML('beforeend', line)
      })
    }

    this.addRemoveEventListener()

  }

  validateFile(file)
  {

    const allowedExtensions = ['jpeg','jpg','png','pdf'];
    const maxFileSize = 8 //MB

    let response = { error: false, message: '' }

    const ext = file.name.split('.').pop().toLowerCase();
    if($.inArray(ext, allowedExtensions) === -1) {
      response.error = true;
      response.message += 'Faila tips nav atļauts!';
    }

    const size = file.size / 1024 / 1024
    if(size > maxFileSize) {
      response.error = true;
      response.message += 'Maksimālais atļautais faila izmērs ir 8MB!'
    }

    return response
  }

  getUploadedFiles() {
    return this.state.filesArr
  }

  getUploadedName() {
    return this.name
  }
}
